import React from 'react';
import { motion } from 'framer-motion';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/3Uf3XB7zoeQYdkRgVom3Yr/ChatGPT_Image_5_feb_2026,_16_11_23.png';
export function HeroSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-97">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-98">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-green-700 font-bold text-base md:text-lg mb-8 tracking-wide uppercase" data-id="element-99">
          🌿 Aprende, Armoniza y Sana
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mb-10" data-id="element-100">
          <span className="block text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tight leading-[0.9]" data-id="element-101">
            <span className="text-gray-900" data-id="element-102">Mega</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 via-amber-600 to-amber-500" data-id="element-103">
              Pack
            </span>
          </span>
          <span className="block text-3xl md:text-4xl lg:text-5xl font-serif italic text-gray-600 mt-3" data-id="element-104">
            Reiki
          </span>
        </motion.h1>

        <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="block mx-auto max-w-sm mb-10 cursor-pointer" data-id="element-105">
          <img src={PRODUCT_IMG} alt="MegaPack Reiki - Camino Integral del Reiki" className="w-full rounded-lg shadow-2xl hover:shadow-3xl transition-shadow" data-id="element-106" />
        </motion.a>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-xl md:text-2xl font-serif font-bold text-gray-800 mb-5" data-id="element-107">
          Formación completa lista para iniciar
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="text-base md:text-lg text-gray-500 mb-8 leading-relaxed max-w-xl mx-auto" data-id="element-108">
          Todo el material de Reiki que necesitas, ordenado, claro y listo para
          usar, para comenzar tu camino de sanación personal o acompañar a
          otros.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex flex-wrap justify-center gap-6 mb-10 text-gray-600 font-semibold text-base" data-id="element-109">
          <span data-id="element-110">✔ Sin tecnicismos</span>
          <span data-id="element-111">✔ Sin cursos eternos</span>
        </motion.div>

        <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-block px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all" data-id="element-112">
          👉 SÍ, QUIERO ACCEDER AHORA
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-4 text-green-600 font-medium text-sm" data-id="element-113">
          ✅ Garantía de satisfacción de 7 días
        </motion.p>
      </div>
    </section>;
}